import { render, staticRenderFns } from "./RegisterAsBusiness.vue?vue&type=template&id=0d92a948"
import script from "./RegisterAsBusiness.vue?vue&type=script&lang=ts"
export * from "./RegisterAsBusiness.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports